import React from "react";
import { useNavigate, Link } from 'react-router-dom';
import Header from "../Component/Header";
import AdminHeader from "../Component/AdminHeader";
import Footer from "../Component/Footer";
import SubMenu from "../Component/SubMenu";
import { useContext } from 'react';
import { ArgContext } from '../../Context/ArgProvider';

import mainBg from "../../assets/img/bg-busuness-04.jpg";
import cons01 from "../../assets/img/business-13.jpg";
import cons02 from "../../assets/img/business-14.jpg";
import cons03 from "../../assets/img/business-15.jpg";
import cons04 from "../../assets/img/business-16.jpg";
import CallWipia from "./CallWipia";


function ITService() {
    // 화면 이동을 위한 네비게이터 설정
	const navigate = useNavigate();

	// 일반 또는 관리자 header 설정
	const { argInfo } = useContext(ArgContext);
	const isAdmin = argInfo?.role === 'admin';

    return (<>
	<main className="page-wrapper">
		{isAdmin ? <AdminHeader /> : <Header />}
		
      {/* <!-- 메인 미이지 + 슬로건 --> */}
			<section className="sub-bannerWrap comOverview-banner" style={{backgroundImage: `url(`+mainBg+`)`}} >
					<div className="textBox">
						<h2>IT Service</h2>
						<p>위피아는 IT융합 및 스마트 서비스로 고객에게 최적화된 비즈니스 서비스를 지원합니다.</p>
					</div>
					<SubMenu />
			</section>

			<section className="container-auto sec-my bs-consulting-wrap">
					<ul className="consulting-list">
						{/* <!-- Item 01 --> */}
						<li>
							<img src={cons01} alt="Business" />

							<div className="textBox">
								<h4 className="title"><span className="num">01</span> Business</h4>
								<p className="text">위피아는 IT분야에 기술적 전문성을 토대로 고객의 비즈니스 이해에 기반한 가치 창출에 힘쓰고 있습니다.</p>
							</div>
						</li>

						{/* <!-- Item 02 --> */}
						<li>

							<img src={cons02} alt="Customer" />
							<div className="textBox">
								<h4 className="title"><span className="num">02</span> Customer</h4>
								<p className="text">‘고객중심’이라는 가치를 최우선으로 하여 고객이 추구하는 방향성에 부합하는 다양한 형태의 IT서비스를 제공합니다.</p>
							</div>
						</li>

						{/* <!-- Item 03 --> */}
						<li>
							<img src={cons03} alt="Convergence" />

							<div className="textBox">
								<h4 className="title"><span className="num">03</span> Convergence</h4>
								<p className="text">과거-현재-미래로 이어지는 비즈니스 연속성을 위해 IT 기술 융합을 통하여 혁신적인 시스템과 솔루션을 구현합니다.</p>
							</div>
						</li>

						{/* <!-- Item 04 --> */}
						<li>

							<img src={cons04} alt="Needs" />
							<div className="textBox">
								<h4 className="title"><span className="num">04</span> Needs</h4>
								<p className="text">고객이 원하는 형태의 업무 시스템 구축, 유지보수 및 아웃소싱등 다양한 상황을 반영하는 컨설팅을 제공합니다.</p>
							</div>
						</li>

					</ul>
			</section>
            <CallWipia />
		</main>
	<Footer />
			

        </>
    )
}

export default ITService;